import { apiAction, apiFetch } from 'utils';
import DuckEntity from './DuckEntity';

const reviewCriteria = (
  new DuckEntity(
    'reviewCriterias',
    {
      apiPath: 'review_criteria',
      jsonIndexRoot: 'review_criteria'
    }
  )
);

reviewCriteria.actions.checkRatings = (ids) => {
  const idsQuery = ids.map(id => `ids[]=${id}`).join('&');
  return (
    apiAction(
      reviewCriteria.types.GET_BEGIN, reviewCriteria.types.GET_SUCCESS, reviewCriteria.types.GET_ERROR,
      (state) => apiFetch.get(state, `${reviewCriteria.config.apiPath}/check_ratings?${idsQuery}`),
      { ids }
    ));
};

export default reviewCriteria.reducer;
export { reviewCriteria };
